<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
            <app-side-nav [item]="meetingNav"></app-side-nav>
        </div> -->
  <div class="col-12 p-0 employee-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">

      <div>

        <div *ngIf="!fromHistory" class="breadcrumbs-section pl-2 ml-5">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/invitation-rights">VMS Invitation Rights</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">Details</span>
        </div>


        <div *ngIf="fromHistory" class="breadcrumbs-section pl-2 ml-5">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/invitation-rights">VMS Invitation Rights</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/history">History</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">Details</span>
        </div>

        <div class="history-layout">

          <div class="row">
            <div class="col-12">
              <h1>Request Details</h1>
            </div>
          </div>


          <div class="row mt-4">
            <div class="col-6">
              <p class="title">Company Name</p>
              <p class="result">HTP Labs</p>
            </div>
            <div class="col-6">
              <p class="title">VMS Invitation Rights</p>
              <p class="result">Creator,Innovator</p>
            </div>

          </div>

          <div class="row" *ngIf="data?.isApproved">
            <div class="col-12">
              <p class="green-text">Approved on {{formatDate(data?.approvalDate, 'date')}}</p>
            </div>
          </div>

          <div class="row" *ngIf="!data?.isApproved">
            <div class="col-12">
              <p class="orange-text ">Approval awaited</p>
            </div>
          </div>


          <div *ngIf="individualInvite">
            <div class="row">
              <div class="col-8 title">12 employees</div>
              <div class="col-4 title" style="text-align: right;">Request sent on 22 mar,2021</div>
            </div>

            <div class="guest  mt-3" *ngFor="let item of data?.t0600Vmsguests;let i=index">

              <div class="row">
                <div class="col-12">
                  <h1>Employee {{i+1}}</h1>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-4">
                  <p class="title">Full Name</p>
                  <p class="result">Shivam Shukla</p>
                </div>
                <div class="col-4">
                  <p class="title">Mobile Number</p>
                  <p class="result">9897679976</p>
                </div>
                <div class="col-4">
                  <p class="title">Email ID</p>
                  <p class="result">shivam&#64;gmail.com</p>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12">
                  <p class="title">Invite Access</p>
                  <p class="result">Creator</p>
                </div>
              </div>

            </div>
          </div>


          <div *ngIf="!individualInvite">

            <div class="row">
              <div class="col-8 title">{{data?.t0600Vmsguests?.length}} Guests</div>
              <div class="col-4 title" style="text-align: right;">Request sent on
                {{formatDate(data?.createdDate, 'date')}}</div>
            </div>

            <table class="table table-borderless table-striped table-curved mt-4" id="pdfTable" #pdfTable>
              <thead>
                <tr>

                  <th>Sr.No</th>
                  <th>Employee Name</th>
                  <th>Email Id</th>
                  <th>Contact Number</th>
                  <th></th>

                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let content of data?.t0600Vmsguests;let i=index" [id]="generateUniqueId(i,'th')">

                  <td>{{i+1}}</td>
                  <td>{{content?.fullName}}</td>
                  <td>{{content?.email}}</td>
                  <td>{{content?.mobile}}</td>
                  <td></td>
                  <td>
                    <i class="fa fa-2x fa-trash" aria-hidden="true"
                      (click)="deleteSelected(data?.guestId,i)"></i>
                  </td>
                </tr>

              </tbody>
            </table>

          </div>

        </div>

        <div class="footer-layout" *ngIf="fromHistory">
          <button class="button-resend">Re-Invite</button>
        </div>


        <div class="footer-layout" *ngIf="!fromHistory">
          <button class="button-cancel" (click)="cancelInvite(data?.t0600Vmsguests[0]?.invitationId)">Cancel
            Request</button>
          <button class="button-resend">Resend Remainder</button>
        </div>

        <!-- <app-footer></app-footer> -->

      </div>
    </div>
